import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const testimonials = [['RM', 'Roxana M.', 'Buenos Aires', 'Dejé de improvisar con la comida. En dos semanas la hinchazón bajó muchísimo y ya sé qué me cae mal.'], ['VS', 'Valeria S.', 'La Plata', 'El semáforo de alimentos me salvó. Ahora puedo salir a comer afuera sin terminar con la panza dura.'], ['DR', 'Daniela R.', 'Quilmes', 'Por primera vez tengo un plan ordenado. Menos gases, menos dolor y mucha más energía a la tarde.'], ['SG', 'Silvia G.', 'San Isidro', 'Había probado mil dietas. Esto me dio el paso a paso que me faltaba y lo pude sostener.']] as const;
const extended = [['Roxana M.', 'Buenos Aires', '“Dejé de improvisar con la comida. En dos semanas la hinchazón bajó muchísimo y ya sé qué me cae mal.”'], ['Valeria S.', 'La Plata', '“El semáforo de alimentos me salvó. Ahora puedo salir a comer afuera sin terminar con la panza dura.”'], ['Daniela R.', 'Quilmes', '“Por primera vez tengo un plan ordenado. Menos gases, menos dolor y mucha más energía a la tarde.”'], ['Silvia G.', 'San Isidro', '“Había probado mil dietas. Esto me dio el paso a paso que me faltaba y lo pude sostener.”'], ['Marta L.', 'Flores', '“Vivía con la panza inflamada todos los días. Con el protocolo cambió la rutina y también mi descanso.”']] as const;
function Stars() {
  return <div className="flex gap-1 text-brand-gold" aria-label="5 de 5 estrellas" data-id="element-167" data-mp="1zc0gtfyp35e5">
      {[1, 2, 3, 4, 5].map(item => <StarIcon key={item} className="h-4 w-4 fill-current" aria-hidden="true" data-id="element-168" data-mp="24a1z3yoar0ok" />)}
    </div>;
}
export function StatsAndProof() {
  const stats = [['+380', 'personas ya usando el protocolo'], ['300+', 'páginas paso a paso'], ['5', 'bonos incluidos'], ['4.8/5', 'calificación']];
  return <>
      <section className="border-y border-brand-green/20 bg-brand-ink px-4 py-14 sm:py-20" data-id="element-169" data-mp="2i41kcvmezjtw">
        <div className="mx-auto grid max-w-3xl grid-cols-2 gap-x-5 gap-y-10" data-id="element-170" data-mp="2n1unffsf7xpy">
          {stats.map(([value, label]) => <div key={label} className="text-center" data-id="element-171" data-mp="mwpga61gpajm">
              <p className="font-display text-4xl font-bold sm:text-6xl" data-id="element-172" data-mp="iyhyd7v9i36u">{value}</p>
              <p className="mt-2 text-xs font-semibold leading-tight text-brand-light sm:text-sm" data-id="element-173" data-mp="wp4yn4go8151">
                {label}
              </p>
            </div>)}
        </div>
      </section>

      <section className="bg-brand-dark px-4 py-16 sm:py-20" data-id="element-174" data-mp="16m9njc1wiapj">
        <div className="mx-auto max-w-6xl" data-id="element-175" data-mp="16ovvvdwm8u8t">
          <h2 className="mb-10 text-center font-display text-2xl font-bold text-brand-light sm:text-3xl" data-id="element-176" data-mp="11mwpdv5kxh7n">
            💬 LO QUE DICEN QUIENES YA LO APLICAN
          </h2>
          <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-4" data-id="element-177" data-mp="1aow7kqsbyrc6">
            {testimonials.map(([initials, name, place, quote], index) => <motion.article key={name} initial={{
            opacity: 0,
            y: 15
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.06
          }} className="flex h-full flex-col rounded-2xl border border-white/10 bg-brand-ink p-6" data-id="element-178" data-mp="3hfm8aq35dgmy" data-mpi={index}>
                <div className="flex items-center gap-3" data-id="element-179" data-mp="1j6gd5cbuwtdg">
                  <div className="grid h-11 w-11 shrink-0 place-items-center rounded-full border border-brand-green/40 font-bold text-brand-light" data-id="element-180" data-mp="1j3u6dewsihwa">
                    {initials}
                  </div>
                  <div data-id="element-181" data-mp="199trwmfmc0aw">
                    <h3 className="font-bold" data-id="element-182" data-mp="1e73ezvfjbzvk">{name}</h3>
                    <p className="text-sm text-slate-400" data-id="element-183" data-mp="1e7v9f2xebrk9">{place}</p>
                  </div>
                </div>
                <div className="mt-5" data-id="element-184" data-mp="1095dvrq85zy0">
                  <Stars data-id="element-185" data-mp="147mctnzhs44c" />
                </div>
                <p className="mt-4 italic leading-relaxed text-slate-300" data-id="element-186" data-mp="14agw3c6rriw6">“{quote}”</p>
              </motion.article>)}
          </div>
        </div>
      </section>
    </>;
}
export function ExtendedTestimonials() {
  return <section className="border-y border-white/10 bg-brand-dark px-4 py-14 sm:py-20" data-id="element-187" data-mp="29watnepg0ihn">
      <div className="mx-auto max-w-5xl" data-id="element-188" data-mp="24wxwo14uxv1c">
        <h2 className="mb-10 text-center font-display text-2xl font-bold text-brand-light sm:text-3xl" data-id="element-189" data-mp="24xzjf2v8k5yw">
          LO QUE DICEN QUIENES YA LO APLICAN
        </h2>
        <div className="grid gap-7 md:grid-cols-2" data-id="element-190" data-mp="1uyqrsgnuf3fp">
          {extended.map(([name, place, quote]) => <article key={name} className="border-l-2 border-brand-green pl-4" data-id="element-191" data-mp="1qxf44goj4sa5">
              <Stars data-id="element-192" data-mp="1m66ov40iqcp2" />
              <p className="mt-2 font-bold" data-id="element-193" data-mp="1m5wzninas9kf">
                {name} <span className="font-normal text-slate-400" data-id="element-194" data-mp="1m43sm28rvnbw">· {place}</span>
              </p>
              <p className="mt-2 text-sm italic leading-relaxed text-slate-300" data-id="element-195" data-mp="1h4zjfblulplk">{quote}</p>
            </article>)}
        </div>
      </div>
    </section>;
}